/**
 * @typedef {import ('../../../propTypes/map/location').Location} Location
 * @typedef {import ('../../../propTypes/map/location').BoundingBox} BoundingBox
 * @typedef {import('@types/leaflet').Map?} Map
 */

/**
 * @param {Map} map
 * @returns {Location}
 */
export const getLocationFromMap = (map) => {
  const { lat, lng } = map.getCenter();
  const zoom = map.getZoom();

  return {
    center: { lat, lon: lng },
    zoom,
  };
};

/**
 * @param {Map} map
 * @returns {BoundingBox}
 */
export const getBoundingBoxFromMap = (map) => {
  // It's possible for getBounds() to not be ready if the map has no size or view yet.
  if (!map || typeof map.getBounds !== 'function') {
    return null;
  }

  // Add check for map container's validity to avoid Leaflet internal property errors during transitions

  const hasValidContainer =
    Object.prototype.hasOwnProperty.call(map, '_container') &&
    map._container &&
    map._container.parentNode;

  if (!hasValidContainer) {
    return null;
  }

  try {
    const bounds = map.getBounds();

    if (!bounds) {
      // Leaflet getBounds() can return undefined if map is not initialized
      return null;
    }

    // WARNING: Do not use destructuring here on `bounds` and its inner functions. This will
    // break the this context and cause the function to throw.
    // Ensure bounds has the necessary methods before calling them.
    if (
      typeof bounds.getNorth !== 'function' ||
      typeof bounds.getSouth !== 'function' ||
      typeof bounds.getEast !== 'function' ||
      typeof bounds.getWest !== 'function'
    ) {
      // This case should ideally not be hit if 'bounds' is a valid LatLngBounds object,
      // but defensive check doesn't hurt.
      return null;
    }
    const bbox = {
      north: bounds.getNorth(),
      south: bounds.getSouth(),
      east: bounds.getEast(),
      west: bounds.getWest(),
    };
    return bbox;
  } catch (_error) {
    return null;
  }
};
